<template>
  <div>
    <NavBar></NavBar>
    <div class="container">
      <div class="row">
        <template v-if="errored">
          <b-alert variant="danger" show>
            Sorry. System we're not able to retieve this information
          </b-alert>
        </template>
        <template v-else>
          <template v-if="loading">
            <b-icon icon="three-dots" animation="cylon" font-scale="4"></b-icon>
          </template>
          <template v-else>
            <PackageCard
              v-for="pack in info"
              :key="pack.pack_id"
              v-bind:packname="pack.pack_name"
              class="col-md-6"
              v-bind:state="pack.status"
              v-bind:endday="pack.updated_on | justdate"
              v-bind:maxadmins="pack.max_admin"
              v-bind:maxusers="pack.max_users"
              v-bind:maxadis="pack.max_adis"
              v-bind:contractlength="pack.contract_length"
              v-bind:initpay="pack.init_payment"
              v-bind:regpay="parseInt(pack.reg_payment)"
              v-bind:payfreq="pack.pay_freq"
              v-bind:promocode="pack.promo_code"
              v-bind:tcref="pack.tandc_version"
              v-bind:addedon="pack.created_on"
            ></PackageCard>
          </template>
        </template>
      </div>
    </div>
    <UserCheck></UserCheck>
    <Footer></Footer>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer.vue";
import PackageCard from "@/components/SubCompViewPackage.vue";
import ServerLinks from "../config.js";
import axios from "axios";
import UserCheck from "@/components/CompUserCheck.vue";
//import Package from "@/assets/dbp.json";

export default {
  name: "ViewPackages",
  components: {
    NavBar,
    PackageCard,
    UserCheck,
    Footer
  },
  data() {
    return {
      info: null,
      loading: true,
      errored: false
    };
  },
  mounted() {
    //console.log(Package);
    let fdgp = new FormData();
    fdgp.append("getpackages", "getpackages");
    axios
      .post(ServerLinks.SERVERCTRL, fdgp)
      .then(response => {
        let dt = response.data;
        //console.log(dt);
        this.info = dt;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => (this.loading = false));
  }
};
</script>
